import React from "react";
import { WarningCircle, ArrowClockwise, House } from "@phosphor-icons/react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, info);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ error: null });
    window.location.href = "/";
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen grid place-items-center bg-orange-50 px-6" data-testid="error-boundary">
        <div className="max-w-lg w-full text-center">
          <div className="mx-auto h-16 w-16 rounded-full bg-orange-100 grid place-items-center mb-6">
            <WarningCircle size={36} weight="duotone" className="text-orange-600" />
          </div>
          <div className="label-cap text-orange-700 mb-2">Something went wrong</div>
          <h1 className="font-display text-4xl font-black text-orange-950 mb-3">
            We hit a snag.
          </h1>
          <p className="text-orange-900/80 leading-relaxed">
            The page couldn't be rendered right now. Your data is safe — just refresh, or head
            back to the dashboard and try again.
          </p>

          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              onClick={this.handleReload}
              data-testid="error-reload-btn"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-sm bg-orange-600 hover:bg-orange-700 text-white font-semibold"
            >
              <ArrowClockwise size={16} weight="bold" /> Reload
            </button>
            <button
              onClick={this.handleHome}
              data-testid="error-home-btn"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-sm bg-white border border-orange-300 text-orange-800 hover:bg-orange-100 font-semibold"
            >
              <House size={16} weight="bold" /> Dashboard
            </button>
          </div>

          {process.env.NODE_ENV !== "production" && (
            <details className="mt-8 text-left text-xs text-orange-900/60 bg-orange-100/60 border border-orange-200 rounded-sm p-3">
              <summary className="cursor-pointer font-semibold uppercase tracking-wider">
                Developer details
              </summary>
              <pre className="mt-2 whitespace-pre-wrap break-all font-mono">
                {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
